const invertedMessages = {
  'Welcome to ID Proofing': 'external.anonymous.text.welcome',
  'ID Proofing Setup Session Expired': 'external.anonymous.text.expired',
  'If you need to access the below link to this page again, please reach out to your organization’s support team.':
    'external.anonymous.text.expired.subText',
  'To begin the ID proofing process, you will be securely redirected to Identity Proofing website to complete your identity verification.':
    'external.anonymous.text.subText',
  'Start ID Proofing': 'external.anonymous.start',
  'Start ID Proofing on IDDataweb': 'external.anonymous.start.btn',
  'One-time access only!': 'external.anonymous.confirmation.title',
  'This link can only be accessed once. After clicking, it will no longer be available. Please keep your information ready for identity proofing before proceeding.':
    'external.anonymous.confirmation.subtitle',
  Apply: 'external.idp.apply',
  Cancel: 'external.idp.cancel',
};

export default invertedMessages;
